export const CONTRACT_TABLE_COLORS = {
  border: '#E5E7EB',
  text: {
    primary: '#111827',
    secondary: '#374151',
    muted: '#6B7280',
  },
  background: {
    primary: '#FFFFFF',
    secondary: '#F8F9FA',
    hover: '#F9FAFB',
  },
} as const;

export const contractTableStyles = {
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: 0,
    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${CONTRACT_TABLE_COLORS.border}`,
      padding: '16px',
      verticalAlign: 'middle',
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  tableHeader: {
    fontWeight: 500,
    color: CONTRACT_TABLE_COLORS.text.muted,
    fontSize: '14px',
    height: '44px',
    backgroundColor: CONTRACT_TABLE_COLORS.background.secondary,
    borderBottom: `1px solid ${CONTRACT_TABLE_COLORS.border}`,
    whiteSpace: 'nowrap',
    padding: '16px',
    textAlign: 'center',
    '&:first-of-type': {
      borderTopLeftRadius: '8px',
    },
    '&:last-of-type': {
      borderTopRightRadius: '8px',
    },
  },
  tableCell: {
    fontSize: '14px',
    color: CONTRACT_TABLE_COLORS.text.primary,
    fontWeight: 400,
    whiteSpace: 'nowrap',
    textAlign: 'center',
    padding: '16px',
  },
  tableRow: {
    '&:hover': {
      backgroundColor: CONTRACT_TABLE_COLORS.background.hover,
    },
  },
  verticalDivider: {
    borderRight: `1px solid ${CONTRACT_TABLE_COLORS.border}`,
  },
  // For expandable rows
  childRow: {
    '& .MuiTableCell-root': {
      color: '#7E8796',
    },
  },
  expandIcon: {
    cursor: 'pointer',
    color: CONTRACT_TABLE_COLORS.text.muted,
  },
};
